import React from "react";

import { Button } from "aible";

import AibleStep from "containers/CreateWizard/AibleStep";

import { Range } from "rc-slider";

import styles from "./style.module.css";

export default class ContinuousCounts extends React.PureComponent {
  render() {
    const {
      id,
      isShow,
      isHideCounts,
      conversionGain,
      conversionCost,
      conversionSaved,
      conversionMissed,
      timePeriod,
      threshold,
      outcome,
      options,
      updateThreshold,
      updateTimePeriod,
      updateIsHideCounts,
      updateConversionGain,
      updateConversionCost
    } = this.props;

    const isLocked = options && options["lock"];

    return (
      <div className={styles.body}>
        <AibleStep
          id={id}
          bId={"continuousCounts"}
          message={"How close to the actual does the AI prediction need to be for you to consider it “good enough”?"}
          isBreak={true}
          optionsHolder={false}
        />
        {threshold && isHideCounts !== true && (
          <div className={styles.outerHolder}>
            <div className={styles.sliderBody}>
              <div className={styles.rangeHolder}>
                <div className={styles.contLabel}>{Math.abs(threshold[0]) + "%" + " (Underestimate)"}</div>
                <Range
                  min={-100}
                  max={100}
                  value={threshold}
                  included={true}
                  onChange={isLocked ? () => {} : (val) => updateThreshold(val)}
                  className={styles.sliderHolder}
                />
                <div className={styles.contLabel}>{Math.abs(threshold[1]) + "%" + " (Overestimate)"}</div>
              </div>
            </div>
          </div>
        )}
        <div className={styles.advancedBtn}>
          <Button type="secondary" onClick={() => updateIsHideCounts(!isHideCounts)}>
            {isHideCounts ? "Show Advanced" : "I Don't Know"}
          </Button>
        </div>
      </div>
    );
  }
}
